import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_paper_party: FaireCategoryEntity = {
  token: "cat_paper-party",
  type: "category",
  name: "Party supplies",
  level: 2,
  parentToken: "cat_paper-novelty",
  href: "/category/party-supplies",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
